import CompanyCategoryTypes from 'store/actionTypes/companyCategory'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  system: []
}

const companyCategory = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case CompanyCategoryTypes.GET_COMPANY_CATEGORIES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case CompanyCategoryTypes.GET_SYSTEM_COMPANY_CATEGORIES_SUCCESS:
      return {
        ...state,
        system: payload?.items
      }
    case CompanyCategoryTypes.GET_COMPANY_CATEGORY_SUCCESS:
      return { ...state, current: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default companyCategory
